import axiosInstance from '../utils/axiosInstance';

export async function getEmployeeDetails(employeeId) {
  if (employeeId?.employeeId) {
    const { data } = await axiosInstance.get(`/employee/fetch-employee/${employeeId.employeeId}`);
    return data;
  } else {
    const { data } = await axiosInstance.get(`/employee/fetch-employee`);
    return data;
  }
}

// "My team": { is_manager, duties: { leave, appraisals, pips, goals }, members }
export async function getMyTeamSummary() {
  const { data } = await axiosInstance.get(`/employee/team/summary`, { workspace: "admin" });
  return data?.data ?? data;
}

export async function updateEmployeeProfilePhoto(file) {
  const formData = new FormData();
  formData.append("profile", file)
  const { data } = await axiosInstance.post(`/employee/employee-profile`, formData);
  return data;
}


export async function updateEmployeeProfile(payload) {
  const { data } = await axiosInstance.put(`/employee/updateEmployeeProfile`, payload);
  return data;
}

//loan

export async function fetchLoanHistory(employeeId) {
  if (employeeId.employeeId) {
    const { data } = await axiosInstance.get(`/employee/loan/${employeeId.employeeId}`);
    return data;
  } else {
    const { data } = await axiosInstance.get(`/employee/loan`);
    return data;
  }
}

export async function applyLoan(payload, employeeId) {
  if (employeeId.employeeId) {
    const { data } = await axiosInstance.post(`/employee/loan/${employeeId.employeeId}`, payload);
    return data;
  } else {
    const { data } = await axiosInstance.post(`/employee/loan`, payload);
    return data;
  }
}

export async function fetchExistingLoansEMI(employeeId) {
  if (employeeId.employeeId) {
    const { data } = await axiosInstance.get(`/employee/existing-emi/${employeeId.employeeId}`);
    return data;
  } else {
    const { data } = await axiosInstance.get(`/employee/existing-emi`);
    return data;
  }
}

export async function uploadEmployeeDocs(data) {
  const res = await axiosInstance.post(`/employee/uploadDocs`, data);
  return res;
}

export async function fetchEmployeeDocuments() {
  const res = await axiosInstance.get(`/employee/documents`);
  return res.data.data ?? [];
}

export async function getSignedURL(key) {
  const res = await axiosInstance.get(`/employee/signedURL`, { params: { key } });
  return res.data.url;
}

export async function deleteDocument(id, employeeId) {
  if (employeeId.employeeId) {
    const res = await axiosInstance.delete(`/employee/document/${id}/${employeeId.employeeId}`);
    return res;
  } else {
    const res = await axiosInstance.delete(`/employee/document/${id}`);
    return res;
  }
}

export async function getEmployeeEarningsOverview(all_years, year, employeeId) {
  const res = await axiosInstance.get(`/employee/earnings-overview`, { params: { all_years, year, id: employeeId.employeeId } });
  return res.data.data ?? [];
}

export async function recordAttendance(payload) {
  const { data } = await axiosInstance.post(`/employee/daily-attendances`, payload);
  return data;
}

export async function getNotifications() {
  const { data } = await axiosInstance.get(`/employee/notifications`);
  return data;
}

export async function MarkAsALLReadNotifications() {
  const { data } = await axiosInstance.put(`/employee/notification/mark-all-read`);
  return data;
}

export async function MarkAsReadNotificationbyId(id, is_read) {
  const { data } = await axiosInstance.put(`/employee/notification/mark/${id}`, { params: { is_read } });
  return data;
}


// Notifications page: { items, total, unread, page, limit }.
// status: "all" | "unread" | "read"
export async function getNotificationsPage({ page = 1, limit = 20, status = "all" } = {}) {
  const { data } = await axiosInstance.get(`/employee/notifications`, {
    params: { page, limit, status },
  });
  const result = data?.data ?? data;
  if (!Array.isArray(result)) return result;

  // An API from before paging ignores the params and returns the whole feed —
  // filter and page it here so the page still works during a rollout.
  const unread = result.filter((n) => !n.is_read).length;
  const filtered =
    status === "unread"
      ? result.filter((n) => !n.is_read)
      : status === "read"
        ? result.filter((n) => n.is_read)
        : result;
  return {
    items: filtered.slice((page - 1) * limit, page * limit),
    total: filtered.length,
    unread,
    page,
    limit,
  };
}

// Clears one notification for the current user only.
export async function deleteNotificationById(id) {
  const { data } = await axiosInstance.delete(`/employee/notification/${id}`);
  return data;
}

export async function deleteAllNotification() {
  const { data } = await axiosInstance.delete(`/employee/notification/clear-all`);
  return data;
}

export async function getMyMonthlyAttendanceSummary() {
  const { data } = await axiosInstance.get(`/employee/monthly-attendance-summary`);
  return data;
}

export async function getRatingData() {
  const { data } = await axiosInstance.get(`/employee/rating-data`);
  return data;
}

export async function changeUserPassword(passwordData) {
  const res = await axiosInstance.put(`/employee/password`,{passwordData});
  console.log("RESPONSE  ", res);
  
  return res;
}

export async function fetchEncashmentDetails() {
  const { data } = await axiosInstance.get(`/employee/encash`);
  return data.data;
}

export async function requestLeaveEncashment(payload) {
  const { data } = await axiosInstance.post(`/employee/encash`, payload);
  return data.Data;
}

export async function deleteProfilePhoto() {
  const { data } = await axiosInstance.delete(`/employee/profile-photo`);
  return data;
}
